<h3 class="nv-label">{{ 'INCIDENT.ATTACHMENT' | translate }}</h3>
<div class="container" appDragDropFile (onFileDropped)="onFileDropped($event)" *ngIf="!(files && files[0]);else filesViewer">
    <input class="cursor-pointer" type="file" #fileDropRef id="fileDropRef" (change)="fileBrowseHandler($event)" />
    <span>
        <label for="fileDropRef" class="cursor-pointer">{{'INCIDENT.UPLOAD_FILE.FILE_INPUT' | translate }}</label> {{'INCIDENT.UPLOAD_FILE.DRAG' | translate }}
    </span>
</div>
<ng-template #filesViewer>
    <section class="nv-files-list">
        <div class="nv-single-file" *ngFor="let file of files; let i = index">
            <fa-icon class="cursor-pointer nv-file-icon me-4" [ngClass]="{'nv-icon-loading': file?.progress < 100, 'nv-icon-loaded': file?.progress === 100}" [icon]="file?.progress < 100 ? faFile : faFileCircleCheck"></fa-icon>
            <div class="nv-info">
                <h4 class="nv-name">
                    {{ file?.name }} 
                    <span class="nv-size">
                        ({{ formatBytes(file?.size) }})
                    </span>
                </h4>               
                <app-progress [progress]="file?.progress"></app-progress>
            </div>
            <fa-icon (click)="rmFile(i)" class="cursor-pointer withdraw-btn nv-delete" [icon]="faTrash"></fa-icon>
        </div>
    </section>
</ng-template>
<section class="nv-files-list">
    <div class="nv-single-file" *ngFor="let file of errorMessages; let i = index">
        <div class="nv-file-icon">
            <fa-icon class="cursor-pointer nv-file-icon me-4 nv-delete" [icon]="faFileCircleExclamation"></fa-icon>
        </div>
        <div class="nv-info pt-3">
            <h4 class="nv-name">
                {{ file.file.name }}
                <span class="nv-size">
                    {{ formatBytes(file.file.size) }}
                </span>
            </h4>          
            <p class="nv-msg-error">{{ file.msg | translate:  {maxSize: maxSize} }}</p>
        </div>
    </div>
</section>